import { useCallback } from 'react';
import { getLocationsIfEmpty } from '../../../../actions/geo/getLocationsIfEmpty';
import { useAppDispatch } from '../../../../hooks/useAppDispatch/useAppDispatch';

export const useHandleReloadPopularRegions = () => {
  const dispatch = useAppDispatch();

  return useCallback(() => dispatch(getLocationsIfEmpty()), [dispatch]);
};
